import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Checkbox,
  Input,
  Button
} from 'semantic-ui-react'

const PeriodontiumExam = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        style={{ width: "100%", height: "100%", padding: "5px" }}>
        <div
          style={{ padding: "5px",  backgroundColor: "#2D9CDB", color: "white", fontWeight: "bold", fontSize: "1.5em" }}>
          Periodontal
        </div>
        <div
          style={{ padding: "10px", display: "grid", gridTemplateColumns: "20% 20% 60%", gridTemplateRows: "repeat(6, 1fr)" }}>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <label
              style={{ marginRight: "10px", fontWeight:"bold" }}>
              Gingival contour
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <Checkbox
              checked={props.periodontalExamData?.gingivalContore1?.value || false}
              label="Normal"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ? null : 3 , "gingivalContore", label)}
              style={{  marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <Checkbox
              checked={props.periodontalExamData?.gingivalContore2?.value || false}
              label="Abnormal"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, "gingivalContore", label)}
              style={{marginRight: "10px" }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "gingivalContore3", value: value,  text: value, input: true } })}
              readOnly={props.periodontalExamData?.gingivalContore2?.value === false || props.periodontalExamData?.gingivalContore2?.value === undefined}
              style={{ width: "100%", marginLeft: "20px" }}
              value={props.periodontalExamData?.gingivalContore3?.value || ""}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              Gingival color
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <Checkbox
              checked={props.periodontalExamData?.gingivalColor1?.value || false}
              label=" Normal"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ? null : 3 , "gingivalColor", label)}
              style={{  marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <Checkbox
              checked={props.periodontalExamData?.gingivalColor2?.value || false}
              label="Abnormal"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, "gingivalColor", label)}
              style={{marginRight: "10px" }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "gingivalColor3", value: value, text: value, input: true } })}
              readOnly={props.periodontalExamData?.gingivalColor2?.value === false || props.periodontalExamData?.gingivalColor2?.value === undefined}
              style={{ width: "100%", marginLeft: "20px" }}
              value={props.periodontalExamData?.gingivalColor3?.value || ""}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <label
              style={{ marginRight: "10px", fontWeight:"bold"  }}>
              Gingival texture
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <Checkbox
              checked={props.periodontalExamData?.gingivalTexture1?.value || false}
              label="Normal"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ? null : 3 , "gingivalTexture", label)}
              style={{  marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <Checkbox
              checked={props.periodontalExamData?.gingivalTexture2?.value || false}
              label="Abnormal"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, "gingivalTexture", label)}
              style={{marginRight: "10px" }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "gingivalTexture3", value: value, text: value, input: true } })}
              readOnly={props.periodontalExamData?.gingivalTexture2?.value === false  || props.periodontalExamData?.gingivalTexture2?.value === undefined}
              style={{ width: "100%", marginLeft: "20px" }}
              value={props.periodontalExamData?.gingivalTexture3?.value || ""}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              Tooth mobility
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.periodontalExamData?.toothMobility1?.value || false}
              label="No"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ? null : 3 , "toothMobility", label)}
              style={{  marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.periodontalExamData?.toothMobility2?.value || false}
              label="Yes"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, "toothMobility", label)}
              style={{marginRight: "50px" }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "toothMobility3", value: value, text: value, input: true } })}
              readOnly={props.periodontalExamData?.toothMobility2?.value === false || props.periodontalExamData?.toothMobility2?.value === undefined}
              style={{ width: "100%", marginLeft: "10px" }}
              value={props.periodontalExamData?.toothMobility3?.value || ""}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              Pocket &gt;= 4 mm.
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.periodontalExamData?.pocket1?.value || false}
              label="No"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ?  null : 3 , "pocket", label)}
              style={{  marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.periodontalExamData?.pocket2?.value || false}
              label="Yes"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, "pocket", label)}
              style={{marginRight: "50px" }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "pocket3", value: value, text: value, input: true } })}
              readOnly={props.periodontalExamData?.pocket2?.value === false || props.periodontalExamData?.pocket2?.value === undefined}
              style={{ width: "100%", marginLeft: "10px" }}
              value={props.periodontalExamData?.pocket3?.value || ""}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              Bleeding
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.periodontalExamData?.bleeding1?.value || false}
              label="No"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ?  null : 3, "bleeding", label)}
              style={{  marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.periodontalExamData?.bleeding2?.value || false}
              label="Yes"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, "bleeding", label)}
              style={{marginRight: "50px" }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "bleeding3", value: value, text: value, input: true } })}
              readOnly={props.periodontalExamData?.bleeding2?.value === false || props.periodontalExamData?.bleeding2?.value === undefined}
              style={{ width: "100%", marginLeft: "10px" }}
              value={props.periodontalExamData?.bleeding3?.value || ""}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              Recession
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.periodontalExamData?.recession1?.value || false}
              label="No"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ?  null : 3, "recession", label)}
              style={{  marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.periodontalExamData?.recession2?.value || false}
              label="Yes"
              onChange={(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, "recession", label)}
              style={{marginRight: "50px" }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "recession3", value: value, text: value, input: true } })}
              readOnly={props.periodontalExamData?.recession2?.value === false || props.periodontalExamData?.recession2?.value === undefined}
              style={{ width: "100%", marginLeft: "10px" }}
              value={props.periodontalExamData?.recession3?.value || ""}>
            </Input>
          </div>
          <div
            style={{display: "none", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              Other finding
            </label>
          </div>
          <div
            style={{display: "none", alignItems: "center", margin: "5px" }}>
            
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "otherFinding1", value: value, input: true } })}
              style={{ width: "100%", marginLeft: "10px" }}
              value={props.periodontalExamData?.otherFinding1?.value || ""}>
            </Input>
          </div>
        </div>
        <div
          style={{ padding: "10px", display: "grid", gridTemplateColumns: "20% 80%",  }}>
          
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              Other finding
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "otherFinding1", value: value, input: true } })}
              style={{ width: "100%"  }}
              value={props.periodontalExamData?.otherFinding1?.value || ""}>
            </Input>
          </div>
        </div>
        <div
          style={{ padding: "5px",  backgroundColor: "#2D9CDB", color: "white", fontWeight: "bold", fontSize: "1.5em" }}>
          Oral hygiene
        </div>
        <div
          style={{ padding: "10px", display: "grid", gridTemplateColumns: "20% 20% 60%", gridTemplateRows: "repeat(2, 1fr)" }}>
          
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              Plaque/stain
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.periodontalExamData?.plaqueStain1?.value || false}
              label="No"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "plaqueStain1", value: checked,text:label  } })}
              style={{marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.periodontalExamData?.plaqueStain2?.value || false}
              label="Mild"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "plaqueStain2", value: checked,text:label  } })}
              style={{marginRight: "110px" }}>
            </Checkbox>
            <Checkbox
              checked={props.periodontalExamData?.plaqueStain3?.value || false}
              label="Moderate"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "plaqueStain3", value: checked,text:label  } })}
              style={{marginRight: "80px" }}>
            </Checkbox>
            <Checkbox
              checked={props.periodontalExamData?.plaqueStain4?.value || false}
              label="Heavy"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "plaqueStain4", value: checked,text:label  } })}
              style={{marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              Calculus
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.periodontalExamData?.calculus1?.value || false}
              label="No"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "calculus1", value: checked,text:label  } })}
              style={{marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.periodontalExamData?.calculus2?.value || false}
              label="Mild"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "calculus2", value: checked,text:label  } })}
              style={{marginRight: "110px" }}>
            </Checkbox>
            <Checkbox
              checked={props.periodontalExamData?.calculus3?.value || false}
              label="Moderate"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "calculus3", value: checked,text:label  } })}
              style={{marginRight: "80px" }}>
            </Checkbox>
            <Checkbox
              checked={props.periodontalExamData?.calculus4?.value || false}
              label="Heavy"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedPeriodontalExam", params: { name: "calculus4", value: checked,text:label  } })}
              style={{marginRight: "10px" }}>
            </Checkbox>
          </div>
        </div>
        <div
          style={{display:"flex", justifyContent:"center"}}>
          {}
          <Button
            color="green"
            onClick={props.handleSavePeriodontalExam}
            style={{margin: "5px 0"}}>
            Save
          </Button>
        </div>
      </div>
    )
}


export default PeriodontiumExam

export const screenPropsDefault = {}

/* Date Time : Mon Sep 04 2023 03:17:20 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\", padding: \"5px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "Periodontal"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"5px\",  backgroundColor: \"#2D9CDB\", color: \"white\", fontWeight: \"bold\", fontSize: \"1.5em\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", display: \"grid\", gridTemplateColumns: \"20% 20% 60%\", gridTemplateRows: \"repeat(6, 1fr)\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Checkbox",
      "parent": 4,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.gingivalContore1?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ? null : 3 , \"gingivalContore\", label)"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\" }"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Checkbox",
      "parent": 5,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.gingivalContore2?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, \"gingivalContore\", label)"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\" }"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Checkbox",
      "parent": 7,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.gingivalColor1?.value || false"
        },
        "label": {
          "type": "value",
          "value": " Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ? null : 3 , \"gingivalColor\", label)"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\" }"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Checkbox",
      "parent": 8,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.gingivalColor2?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, \"gingivalColor\", label)"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\" }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Checkbox",
      "parent": 10,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.gingivalTexture1?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ? null : 3 , \"gingivalTexture\", label)"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\" }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Checkbox",
      "parent": 11,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.gingivalTexture2?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, \"gingivalTexture\", label)"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\" }"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "Gingival contour"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\", fontWeight:\"bold\" }"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "Gingival color"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "Gingival texture"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "Tooth mobility"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Input",
      "parent": 5,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"gingivalContore3\", value: value,  text: value, input: true } })"
        },
        "readOnly": {
          "type": "code",
          "value": "props.periodontalExamData?.gingivalContore2?.value === false || props.periodontalExamData?.gingivalContore2?.value === undefined"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", marginLeft: \"20px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.periodontalExamData?.gingivalContore3?.value || \"\""
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Input",
      "parent": 8,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"gingivalColor3\", value: value, text: value, input: true } })"
        },
        "readOnly": {
          "type": "code",
          "value": "props.periodontalExamData?.gingivalColor2?.value === false || props.periodontalExamData?.gingivalColor2?.value === undefined"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", marginLeft: \"20px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.periodontalExamData?.gingivalColor3?.value || \"\""
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Input",
      "parent": 11,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"gingivalTexture3\", value: value, text: value, input: true } })"
        },
        "readOnly": {
          "type": "code",
          "value": "props.periodontalExamData?.gingivalTexture2?.value === false  || props.periodontalExamData?.gingivalTexture2?.value === undefined"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", marginLeft: \"20px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.periodontalExamData?.gingivalTexture3?.value || \"\""
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", justifyContent:\"center\"}"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "Button",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": "Save"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleSavePeriodontalExam"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"5px 0\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "Checkbox",
      "parent": 89,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.toothMobility1?.value || false"
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ? null : 3 , \"toothMobility\", label)"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\" }"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "Checkbox",
      "parent": 90,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.toothMobility2?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, \"toothMobility\", label)"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"50px\" }"
        },
        "toggle": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "Input",
      "parent": 90,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"toothMobility3\", value: value, text: value, input: true } })"
        },
        "readOnly": {
          "type": "code",
          "value": "props.periodontalExamData?.toothMobility2?.value === false || props.periodontalExamData?.toothMobility2?.value === undefined"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", marginLeft: \"10px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.periodontalExamData?.toothMobility3?.value || \"\""
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "Oral hygiene"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"5px\",  backgroundColor: \"#2D9CDB\", color: \"white\", fontWeight: \"bold\", fontSize: \"1.5em\" }"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 99,
      "props": {
        "children": {
          "type": "value",
          "value": "Pocket &gt;= 4 mm."
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "label",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "Bleeding"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "label",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": "Recession"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "Checkbox",
      "parent": 98,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.pocket1?.value || false"
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ?  null : 3 , \"pocket\", label)"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\" }"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Checkbox",
      "parent": 100,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.pocket2?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, \"pocket\", label)"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"50px\" }"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "Checkbox",
      "parent": 102,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.bleeding1?.value || false"
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ?  null : 3, \"bleeding\", label)"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\" }"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Checkbox",
      "parent": 103,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.bleeding2?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, \"bleeding\", label)"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"50px\" }"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "Checkbox",
      "parent": 105,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.recession1?.value || false"
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 1 : 2, checked ? 2 : 1, checked ?  null : 3, \"recession\", label)"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\" }"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "Checkbox",
      "parent": 106,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.recession2?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Yes"
        },
        "onChange": {
          "type": "code",
          "value": "(_e, { checked, label }) => props.handleClearInput(checked ? 2 : 1, checked ? 1 : 2, checked ? null : 3, \"recession\", label)"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"50px\" }"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "Input",
      "parent": 106,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"recession3\", value: value, text: value, input: true } })"
        },
        "onFocus": {
          "type": "code",
          "value": ""
        },
        "readOnly": {
          "type": "code",
          "value": "props.periodontalExamData?.recession2?.value === false || props.periodontalExamData?.recession2?.value === undefined"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", marginLeft: \"10px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.periodontalExamData?.recession3?.value || \"\""
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "Input",
      "parent": 103,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"bleeding3\", value: value, text: value, input: true } })"
        },
        "readOnly": {
          "type": "code",
          "value": "props.periodontalExamData?.bleeding2?.value === false || props.periodontalExamData?.bleeding2?.value === undefined"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", marginLeft: \"10px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.periodontalExamData?.bleeding3?.value || \"\""
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "Input",
      "parent": 100,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"pocket3\", value: value, text: value, input: true } })"
        },
        "readOnly": {
          "type": "code",
          "value": "props.periodontalExamData?.pocket2?.value === false || props.periodontalExamData?.pocket2?.value === undefined"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", marginLeft: \"10px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.periodontalExamData?.pocket3?.value || \"\""
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", display: \"grid\", gridTemplateColumns: \"20% 20% 60%\", gridTemplateRows: \"repeat(2, 1fr)\" }"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "label",
      "parent": 128,
      "props": {
        "children": {
          "type": "value",
          "value": "Plaque/stain"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "Checkbox",
      "parent": 129,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.plaqueStain1?.value || false"
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"plaqueStain1\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\" }"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "Checkbox",
      "parent": 130,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.plaqueStain2?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Mild"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"plaqueStain2\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"110px\" }"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 136,
      "name": "Checkbox",
      "parent": 130,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.plaqueStain3?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Moderate"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"plaqueStain3\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"80px\" }"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "Checkbox",
      "parent": 130,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.plaqueStain4?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Heavy"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"plaqueStain4\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\" }"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "label",
      "parent": 140,
      "props": {
        "children": {
          "type": "value",
          "value": "Calculus"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Checkbox",
      "parent": 141,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.calculus1?.value || false"
        },
        "label": {
          "type": "value",
          "value": "No"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"calculus1\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\" }"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Checkbox",
      "parent": 142,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.calculus2?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Mild"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"calculus2\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"110px\" }"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "Checkbox",
      "parent": 142,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.calculus3?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Moderate"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"calculus3\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"80px\" }"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 150,
      "name": "Checkbox",
      "parent": 142,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.periodontalExamData?.calculus4?.value || false"
        },
        "label": {
          "type": "value",
          "value": "Heavy"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"calculus4\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\" }"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "label",
      "parent": 152,
      "props": {
        "children": {
          "type": "value",
          "value": "Other finding"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "Input",
      "parent": 153,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"otherFinding1\", value: value, input: true } })"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", marginLeft: \"10px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.periodontalExamData?.otherFinding1?.value || \"\""
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", display: \"grid\", gridTemplateColumns: \"20% 80%\",  }"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 157,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 158,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "label",
      "parent": 157,
      "props": {
        "children": {
          "type": "value",
          "value": "Other finding"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "Input",
      "parent": 158,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedPeriodontalExam\", params: { name: \"otherFinding1\", value: value, input: true } })"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"  }"
        },
        "value": {
          "type": "code",
          "value": "props.periodontalExamData?.otherFinding1?.value || \"\""
        }
      },
      "seq": 160,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 40,
  "isMounted": true,
  "memo": false,
  "name": "PeriodontiumExam",
  "project": "cudent",
  "screenPropsDefault": {
  },
  "width": 55
}

*********************************************************************************** */
